import Vue from 'vue';
import Vuex from 'vuex';

import pathify from './pathify';
import { make } from 'vuex-pathify';

import { keyBy, find, findIndex, keys, shuffle, difference, map } from 'lodash';

import {
    prepScreens,
    prepChoices,
    prepTypes,
    prepPrescription,
    prepCommitment,
    prepMotivators,
    prepAdherence,
    prepAdherenceSupport,
    prepAdherenceGaps,
    prepIrregularDownsides,
    prepBarriers,
    prepRegularSupport,
    prepRegularStrategies,
    prepMotivatorsRevisited,
    prepAdherenceRevisited,
    prepRegularStrategiesRevisited,
    prepReminder
} from '@/components/modules/9/prepAdherence';

import { stepUpStepBackChoices, stepUpStepBackPrompts } from '@/components/modules/8/stepUpStepBack';

const notificationChoices = [
    {
        label: `Text my phone`,
        value: `text`
    },
    {
        label: `Email me`,
        value: `email`
    },
    {
        label: `Text and email are both okay`,
        value: `both`
    },
    {
        label: `I don’t want notifications right now`,
        value: `none`
    }
];

const getAClueSlots = [
    {
        text: `I'm...`,
        choices: [
            `feeling tipsy after 2 Smirnoff Ices`,
            `feeling really stimulated and confident after snorting 2 lines of Cocaine`,
            `feeling “loose” and horned up after inhaling Poppers`,
            `high as a kite after smoking a joint`,
            `carefree after throwin’ back a few beers`,
            `feeling really fixated on sex after injecting some Crystal or “Tina”`,
            `drunk and having trouble getting hard`,
            `HARD UP after taking some Viagra`,
            `feeling cuddly and carefree after smoking some weed`,
            `getting horny after having two COCKtails`
        ]
    },
    {
        text: `...and my sex partner is...`,
        choices: [
            `a guy who’s bigger and stronger than me`,
            `a guy my age who told me he doesn’t like to use condoms`,
            `a hot straight guy who says he’s clean and wants to top me bareback (no condom)`,
            `a “gen” guy, or someone who’s paying me for sex and wants to bareback`,
            `an older partner who I trust`,
            `my boyfriend of 2 months (monogamous)`,
            `a partner you don’t know`,
            `a guy who tells you that he’s HIV-positive`,
            `an older guy who’s really into your “type” (ethnicity, size, etc.)`,
            `a stranger I met outside a bar—he’s totally drunk`
        ]
    },
    {
        text: `...and we're...`,
        choices: [
            `at a music festival inside a tent`,
            `inside the car parked outside the movie theater`,
            `in a dark alley near a gay dance club`,
            `in my bedroom at my parents’ place`,
            `at the same hotel I’m staying at alone`,
            `on an empty bus or subway car`,
            `at a cruising spot in a park (outside)`,
            `in a public bathroom`,
            `at his place after we meet on Craigslist`,
            `at the place I’m living at after we connect on Grindr`
        ]
    }
];

const getAClueChoices = () => {
    return keyBy(
        [
            {
                id: 1,
                choices: []
            },
            {
                id: 2,
                choices: []
            },
            {
                id: 3,
                choices: []
            }
        ],
        'id'
    );
};

const wellHungRiskLevels = [
    {
        id: 1,
        riskLevel: 'Higher'
    },
    {
        id: 2,
        riskLevel: 'Medium'
    },
    {
        id: 3,
        riskLevel: 'Lower'
    },
    {
        id: 4,
        riskLevel: 'No Risk'
    }
];

const wellHungPrompts = keyBy(
    [
        {
            id: 1,
            prompt: 'Topping (insertive butt sex) without a condom',
            riskLevel: 1
        },
        {
            id: 2,
            prompt: 'Bottoming (receptive butt sex) without a condom',
            riskLevel: 1
        },
        {
            id: 3,
            prompt: 'Butt sex using a condom and lube',
            riskLevel: 2
        },
        {
            id: 4,
            prompt: 'Fucking a vagina without a condom',
            riskLevel: 2
        },
        {
            id: 5,
            prompt: 'Giving head (sucking someone’s dick) without a condom',
            riskLevel: 3
        },
        {
            id: 6,
            prompt: 'Hand job (rubbing someone’s dick with your hands)',
            riskLevel: 3
        },
        {
            id: 7,
            prompt: '69 (mutual oral sex) without a condom',
            riskLevel: 3
        },
        {
            id: 8,
            prompt: 'Eating pussy (licking someone’s vagina)',
            riskLevel: 3
        },
        {
            id: 9,
            prompt: 'Rimming (licking someone’s ass)',
            riskLevel: 3
        },
        {
            id: 10,
            prompt: 'Kissing',
            riskLevel: 4
        },
        {
            id: 11,
            prompt: 'Sucking titties',
            riskLevel: 4
        }
    ],
    'id'
);

const wellHungOrder = () => {
    return shuffle(keys(wellHungPrompts));
};

const underwearPersonalityStatements = keyBy(
    [
        {
            id: 1,
            statement: 'You like to feel secure.'
        },
        {
            id: 2,
            statement: 'You are super free-spirited.'
        },
        {
            id: 3,
            statement: 'You wear short shorts.'
        },
        {
            id: 4,
            statement: 'You’re a tough guy'
        },
        {
            id: 5,
            statement: 'You put comfort before style.'
        },
        {
            id: 6,
            statement: 'It’s important to have “easy access”.'
        },
        {
            id: 7,
            statement: 'You’re proud of your ASSets.'
        },
        {
            id: 8,
            statement: 'You enjoy fabric with patterns.'
        },
        {
            id: 9,
            statement: 'You are kinky on the weekend.'
        },
        {
            id: 10,
            statement: 'You’ve had skid marks twice in the last month.'
        }
    ],
    'id'
);

const bottomLineStatements = keyBy(
    [
        {
            id: 1,
            statement: 'When I <span class="font-weight-bold">give head</span> (when I suck a guy’s dick):',
            choices: [1, 2, 3, 6]
        },
        {
            id: 2,
            statement: 'When I <span class="font-weight-bold">get head</span> (when a guy sucks my dick):',
            choices: [1, 4, 5, 6]
        },
        {
            id: 3,
            statement: 'When I <span class="font-weight-bold">top</span> (when I put my dick in a guy’s butt):',
            choices: [1, 7, 8, 6]
        },
        {
            id: 4,
            statement: 'When I <span class="font-weight-bold">bottom</span> (when a guy puts his dick in my butt):',
            choices: [1, 9, 10, 6]
        },
        {
            id: 5,
            statement: 'When I <span class="font-weight-bold">rim</span> (when I lick a guy’s ass):',
            choices: [11, 12, 6]
        },
        {
            id: 6,
            statement: 'When I <span class="font-weight-bold">get rimmed</span> (when a guy licks my ass):',
            choices: [11, 12, 6]
        },
        {
            id: 7,
            statement: 'Will I <span class="font-weight-bold">teabag</span> him (suck his balls)?',
            choices: [13, 14]
        },
        {
            id: 8,
            statement: 'Will I let him <span class="font-weight-bold">teabag me</span> (have him suck my balls)?',
            choices: [13, 14]
        },
        {
            id: 9,
            statement: 'Will you <span class="font-weight-bold">jack off</span> together (touch each other’s dicks)?',
            choices: [13, 14]
        }
    ],
    'id'
);

const bottomLineChoices = keyBy(
    [
        {
            id: 1,
            choice: 'I’ll always use a condom'
        },
        {
            id: 2,
            choice: 'I won’t use a condom and I will swallow his cum'
        },
        {
            id: 3,
            choice: 'I won’t use a condom and I will spit out (will not swallow) his cum'
        },
        {
            id: 4,
            choice: 'I won’t use a condom and I will cum inside his mouth'
        },
        {
            id: 5,
            choice: 'I won’t use a condom and I will cum outside his mouth'
        },
        {
            id: 6,
            choice: 'I’ll NEVER do this'
        },
        {
            id: 7,
            choice: 'I won’t use a condom and I will cum inside him'
        },
        {
            id: 8,
            choice: 'I won’t use a condom and I will pull out to cum'
        },
        {
            id: 9,
            choice: 'I won’t use a condom and I will let him cum inside me'
        },
        {
            id: 10,
            choice: 'I won’t use a condom and I will have him pull out to cum'
        },
        {
            id: 11,
            choice: 'I’ll use a barrier/dam'
        },
        {
            id: 12,
            choice: 'I won’t use a barrier/dam'
        },
        {
            id: 13,
            choice: 'Of course!'
        },
        {
            id: 14,
            choice: 'Hell to the no!'
        }
    ],
    'id'
);

const myBottomLine = () => {
    return keyBy(
        [
            {
                statement: 1,
                response: null
            },
            {
                statement: 2,
                response: null
            },
            {
                statement: 3,
                response: null
            },
            {
                statement: 4,
                response: null
            },
            {
                statement: 5,
                response: null
            },
            {
                statement: 6,
                response: null
            },
            {
                statement: 7,
                response: null
            },
            {
                statement: 8,
                response: null
            },
            {
                statement: 9,
                response: null
            }
        ],
        'statement'
    );
};

const myBottomLineResponses = keyBy(
    [
        {
            module: 2,
            myBottomLine: myBottomLine()
        },
        {
            module: 10,
            myBottomLine: myBottomLine()
        },
        {
            module: 15,
            myBottomLine: myBottomLine()
        },
        {
            module: 20,
            myBottomLine: myBottomLine()
        }
    ],
    'module'
);

const myUnderwearPersonality = () => {
    return keyBy(
        [
            {
                statement: 1,
                choice: null
            },
            {
                statement: 2,
                choice: null
            },
            {
                statement: 3,
                choice: null
            },
            {
                statement: 4,
                choice: null
            },
            {
                statement: 5,
                choice: null
            },
            {
                statement: 6,
                choice: null
            },
            {
                statement: 7,
                choice: null
            },
            {
                statement: 8,
                choice: null
            },
            {
                statement: 9,
                choice: null
            },
            {
                statement: 10,
                choice: null
            }
        ],
        'statement'
    );
};

const myPeepInLoveEmotions = () => {
    return keyBy(
        [
            {
                emotion: 1,
                choice: null
            },
            {
                emotion: 2,
                choice: null
            },
            {
                emotion: 3,
                choice: null
            },
            {
                emotion: 4,
                choice: null
            },
            {
                emotion: 5,
                choice: null
            }
        ],
        'emotion'
    );
};

const peepInLoveCommunicationStrategies = () => {
    return keyBy(
        [
            {
                prompt: 1,
                strategy: 'If a partner becomes upset when you insist on a condom, you can live with it and find a partner that respects you as a VIP! (“I get it, but I have a rule about sex and I’m not willing to break it”)',
                response: null
            },
            {
                prompt: 2,
                strategy: 'Share your BottomLine with a boyfriend or partner before you have sex. (“Hey, when it comes to sex, this is how I like to do it.”)',
                response: null
            },
            {
                prompt: 3,
                strategy: 'Refuse risky sex, regardless of how aroused a partner is, to protect your sexual health. (“You’re really hot, but I don’t do it without a condom”)',
                response: null
            },
            {
                prompt: 4,
                strategy: 'Avoid situations that put your BottomLine at risk, like drinking/drugging before or during sex. (“No, thanks I’ll pass on that blunt right now- I’m not feelin’ it, maybe later!”)',
                response: null
            },
            {
                prompt: 5,
                strategy: 'Give yourself a pat on the back when you’re able to maintain your BottomLine in a sexy situation. (“Congrats to me!  I kept my BottomLine even though it was rough!) ',
                response: null
            }
        ],
        'prompt'
    );
};

const peepInLoveCommunicationResponses = keyBy(
    [
        {
            id: 1,
            choice: 'I GOT IT! Totally confident!',
            confident: true
        },
        {
            id: 2,
            choice: 'I’m fairly confident, I think I can do it in most cases!',
            confident: true
        },
        {
            id: 3,
            choice: 'Not confident, I need to work on this!',
            confident: false
        }
    ],
    'id'
);

const myBullsI = () => {
    return [
        {
            id: 1,
            prompt: `What is the <strong>most important</strong> part of your identity? (For example, this might be your race, or where you live, or that you’re right or left-handed. Lol)`,
            next: 2,
            color: `rgb(187, 37, 34)`,
            response: ''
        },
        {
            id: 2,
            prompt: `What is the <strong>next most important</strong> part of your identity?`,
            next: 3,
            color: `rgb(238, 136, 68)`,
            response: ''
        },
        {
            id: 3,
            prompt: `What is the <strong>third most important</strong> part of your identity?`,
            next: 4,
            color: `rgb(251, 237, 32)`,
            response: ''
        },
        {
            id: 4,
            prompt: `What is the <strong>fourth most important</strong> part of your identity?`,
            next: 5,
            color: `rgb(139, 197, 62)`,
            response: ''
        },
        {
            id: 5,
            prompt: `What is the <strong>fifth most important</strong> part of your identity?`,
            next: null,
            color: `rgb(105, 153, 187)`,
            response: ''
        }
    ];
};

Vue.use(Vuex);

const defaultState = () => ({
    user: null,
    name: '',
    phone: '',
    email: '',
    notifications: '',
    bottomLine: myBottomLineResponses,
    underwearPersonality: myUnderwearPersonality(),
    completed: [],
    finished: false,
    wellHungOrder: wellHungOrder(),
    rubberMishapIncorrect: [],
    getAClueChoices: getAClueChoices(),
    myBullsI: myBullsI(),
    peepInLoveEmotions: myPeepInLoveEmotions(),
    peepInLoveCommunicationStrategies: peepInLoveCommunicationStrategies(),
    resources: [
        {
            topic: 'Alcohol',
            url: 'https://teens.drugabuse.gov/drug-facts/alcohol',
            unlocked: false,
            category: 'Drugs and Alcohol'
        },
        {
            topic: 'Marijuana',
            url: 'https://teens.drugabuse.gov/drug-facts/marijuana',
            unlocked: false,
            category: 'Drugs and Alcohol'
        },
        {
            topic: 'Poppers',
            url: 'https://teens.drugabuse.gov/drug-facts/inhalants',
            unlocked: false,
            category: 'Drugs and Alcohol'
        },
        {
            topic: 'Cocaine',
            url: 'https://teens.drugabuse.gov/drug-facts/cocaine',
            unlocked: false,
            category: 'Drugs and Alcohol'
        },
        {
            topic: 'Crystal Meth',
            url: 'https://teens.drugabuse.gov/drug-facts/methamphetamine-meth',
            unlocked: false,
            category: 'Drugs and Alcohol'
        },
        {
            topic: 'HIV',
            url: 'https://www.cdc.gov/hiv/basics/whatishiv.html',
            unlocked: false,
            category: 'HIV'
        },
        {
            topic: 'PrEP Locator',
            url: 'https://preplocator.org/',
            unlocked: false,
            category: 'HIV'
        },
        {
            topic: 'PrEP Basics',
            url: 'https://www.cdc.gov/hiv/basics/prep.html',
            unlocked: false,
            category: 'HIV'
        },
        {
            topic: 'What is PrEP',
            url: 'http://www.whatisprep.org/',
            unlocked: false,
            category: 'HIV'
        },
        {
            topic: 'About PEP',
            url: 'https://www.cdc.gov/hiv/risk/pep/index.html',
            unlocked: false,
            category: 'HIV'
        },
        {
            topic: 'Sex in the States',
            url: 'https://sexetc.org/action-center/sex-in-the-states/',
            unlocked: false,
            category: 'HIV'
        },
        {
            topic: 'Living with HIV',
            url: 'https://www.cdc.gov/VitalSigns/hiv-aids-medical-care/infographic.html',
            unlocked: false,
            category: 'HIV'
        }
    ],
    content: {
        modules: [
            { id: 1, title: 'Set Up MyPEEPS Profile' },
            { id: 2, title: 'BottomLine' },
            { id: 3, title: 'Underwear Personality Quiz' },
            { id: 4, title: 'My Bulls-I' },
            { id: 5, title: 'P’s On-Again Off-Again BottomLine' },
            { id: 6, title: 'Sexy Settings' },
            { id: 7, title: 'Goin’ Downhill Fast' },
            { id: 8, title: 'Step Up, Step Back' },
            { id: 9, title: 'HIV True/False' },
            { id: 10, title: 'Checking In On Your BottomLine ' },
            { id: 11, title: 'P Gets Woke About Safer Sex' },
            { id: 12, title: 'Testing with Tommy' },
            { id: 13, title: 'Well Hung??' },
            { id: 14, title: 'Ordering Steps to Effective Condom Use' },
            { id: 15, title: 'Checking In On Your BottomLine Again' },
            { id: 16, title: 'Peep in Love' },
            { id: 17, title: '4 Ways to Manage Stigma' },
            { id: 18, title: 'Rubber Mishap' },
            { id: 19, title: 'Get a Clue!' },
            { id: 20, title: 'Last Time Checking In On Your BottomLine' },
            { id: 21, title: 'BottomLine Overview' }
        ],
        bottomLineStatements: bottomLineStatements,
        bottomLineChoices: bottomLineChoices,
        underwearPersonalityStatements: underwearPersonalityStatements,
        wellHungPrompts: wellHungPrompts,
        wellHungRiskLevels: wellHungRiskLevels,
        getAClueSlots: getAClueSlots,
        notificationChoices: notificationChoices,
        peepInLoveCommunicationResponses: peepInLoveCommunicationResponses
    },
    prepScreens,
    prepChoices,
    prepTypes,
    prepPrescription,
    prepCommitment,
    prepMotivators,
    prepAdherence,
    prepAdherenceSupport,
    prepAdherenceGaps,
    prepIrregularDownsides,
    prepBarriers,
    prepRegularSupport,
    prepRegularStrategies,
    prepMotivatorsRevisited,
    prepAdherenceRevisited,
    prepRegularStrategiesRevisited,
    prepReadiness: null,
    prepReminder,
    stepUpStepBackChoices,
    stepUpStepBackPrompts
});

const state = defaultState();
const getters = {
    ...make.getters(state),
    module: (state) => (id) => {
        return state.content.modules.find((module) => module.id === parseInt(id));
    },
    allComplete: (state) => {
        return difference(map(state.content.modules, 'id'), map(state.completed, 'id')).length == 0;
    },
    myUnderwearPersonality: (state) => {
        // don't return a value unless all questions are answered.
        // need to add 1 to each answer because they are zero-based
        let myUnderwearPersonality = 0;

        for (const k of keys(state.underwearPersonality)) {
            if (state.underwearPersonality[k].choice === null) {
                myUnderwearPersonality = null;
                break;
            }

            myUnderwearPersonality += parseInt(state.underwearPersonality[k].choice) + 1;
        }

        return myUnderwearPersonality;
    },
    myBottomLine: (state) => (statement) => {
        // get the response for the specified module/statement, but if that is null, return the response
        // for the next highest module.  If that is also null (should not happen) it can just be returned.
        // this.$store.get(`bottomLine@${this.$route.params.module}.myBottomLine.${this.statement}.response`);
        // const module = state.bottomLine.modules.find((module) => module.module === parseInt(statement.moduleId));
        // const response = module.myBottomLine.find((response) => response.statement === parseInt(statement.statementId));

        const module = find(state.bottomLine, (o) => o.module === parseInt(statement.moduleId));
        let response = find(module.myBottomLine, (o) => o.statement === parseInt(statement.statementId));

        if (response.response === null) {
            const priorModule = find(
                state.bottomLine,
                (o) =>
                    o.module ===
                    parseInt(
                        keys(state.bottomLine)
                            .sort((a, b) => parseInt(b) - parseInt(a))
                            .find((n) => parseInt(n) < parseInt(statement.moduleId))
                    )
            );

            if (priorModule != null) {
                response = find(priorModule.myBottomLine, (o) => o.statement === parseInt(statement.statementId));
            }
        }

        return response.response;
    }
};
const mutations = {
    ...make.mutations(state),
    loadState(state, savedState) {
        Object.assign(state, savedState);
    },
    resetDefaultState(state) {
        Object.assign(state, defaultState());
    },
    complete(state, module) {
        let idx = findIndex(state.completed, { id: module.id });

        if (idx > -1) {
            state.completed.push(Object.assign(module, { timestamp: new Date() }, { repeat: true }));
        } else {
            state.completed.push(Object.assign(module, { timestamp: new Date() }));
        }
    },
    resetModule(state, module) {
        // reset specific module data
        if (module.id === 1) {
            // profile stuff
            state.name = '';
            state.phone = '';
            state.email = '';
            state.notifications = '';
        } else if (module.id === 2) {
            // my bottomline (module 2)
            state.bottomLine[2].myBottomLine = myBottomLine();
        } else if (module.id === 3) {
            // my underwear personality
            state.underwearPersonality = myUnderwearPersonality();
        } else if (module.id === 4) {
            // my BullsI
            state.myBullsI = myBullsI();
        } else if (module.id === 8) {
            // step up step back
            state.stepUpStepBackPrompts = stepUpStepBackPrompts;
        } else if (module.id === 9) {
            // prep adherence
            state.prepChoices = prepChoices;
            state.prepTypes = prepTypes;
            state.prepPrescription = prepPrescription;
            state.prepCommitment = prepCommitment;
            state.prepMotivators = prepMotivators;
            state.prepAdherence = prepAdherence;
            state.prepAdherenceSupport = prepAdherenceSupport;
            state.prepAdherenceGaps = prepAdherenceGaps;
            state.prepIrregularDownsides = prepIrregularDownsides;
            state.prepBarriers = prepBarriers;
            state.prepRegularSupport = prepRegularSupport;
            state.prepRegularStrategies = prepRegularStrategies;
            state.prepMotivatorsRevisited = prepMotivatorsRevisited;
            state.prepAdherenceRevisited = prepAdherenceRevisited;
            state.prepRegularStrategiesRevisited = prepRegularStrategiesRevisited;
            state.prepReadiness = null;
            state.prepReminder = prepReminder;
        } else if (module.id === 10) {
            // my bottomline (module 10)
            state.bottomLine[10].myBottomLine = myBottomLine();
        } else if (module.id === 15) {
            // my bottomline (module 15)
            state.bottomLine[15].myBottomLine = myBottomLine();
        } else if (module.id === 16) {
            // peep in love emotions/communication strategies
            state.peepInLoveEmotions = myPeepInLoveEmotions();
            state.peepInLoveCommunicationStrategies = peepInLoveCommunicationStrategies();
        } else if (module.id === 18) {
            // rubber mishap
            state.rubberMishapIncorrect = [];
        } else if (module.id === 19) {
            // get a clue
            state.getAClueChoices = getAClueChoices();
        } else if (module.id === 20) {
            // my bottomline (module 20)
            state.bottomLine[20].myBottomLine = myBottomLine();
        }

        let idx = findIndex(state.completed, { id: module.id });
        while (idx > -1) {
            state.completed.splice(idx, 1);
            idx = findIndex(state.completed, { id: module.id });
        }
    }
};
const actions = {
    ...make.actions(state)
};

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    plugins: [pathify.plugin]
});
